module.exports = __webpack_public_path__ + "img/founder_photo.74230f1d.jpg";